"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var FieldTypes = _interopRequireWildcard(require("../../utilities/constants/fieldTypes"));

var _isFilledIn = _interopRequireDefault(require("../../utilities/isFilledIn"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// ******************** TRIGGER RULES ********************
// Apply the response behaviors of the given trigger rule to the given field.
var applyTriggerBehaviors = function applyTriggerBehaviors(rule, field, isFirstRender, isUserUpdate) {
  var value = field.value,
      externalName = field.externalName,
      _field$_derived = field._derived,
      isDisabled = _field$_derived.isDisabled,
      isRequired = _field$_derived.isRequired,
      externalNameValue = _field$_derived.externalNameValue;
  var responseBehavior = rule.responseBehavior;
  responseBehavior.forEach(function (_ref) {
    var responseBehaviorType = _ref.responseBehaviorType,
        setValue = _ref.value;
    var wasTriggered = isUserUpdate || isFirstRender;

    switch (responseBehaviorType) {
      case 'enable':
        if (isUserUpdate) value = '';
        isDisabled = false;
        break;

      case 'require':
        isRequired = true;
        break;

      case 'set':
        var isTargetEmpty = !(0, _isFilledIn.default)(value);
        if (isUserUpdate && !isFirstRender || isTargetEmpty && wasTriggered) value = setValue;
        break;

      case 'system':
        var isSystemField = setValue === externalName;
        if (wasTriggered && isSystemField) value = externalNameValue;
        break;

      default:
        throw new Error('Unknown trigger response behavior type.');
    }
  });
  return _objectSpread(_objectSpread({}, field), {}, {
    value: value,
    _derived: _objectSpread(_objectSpread({}, field._derived), {}, {
      isDisabled: isDisabled,
      isRequired: isRequired
    })
  });
}; // Returns the given value coerced to the type required by the given field.


var castValue = function castValue(value, field) {
  if (value == null) return '';
  var fieldType = field._derived.fieldType;

  switch (fieldType) {
    case FieldTypes.CHK:
      return !!value;

    case FieldTypes.NUMBER:
      return parseFloat(value);

    default:
      return "".concat(value).trim();
  }
}; // Returns a bool indicating whether or not a given trigger rule has been fired.
// The condition here is based on the rule's `triggerActionType` object, which
// should look like one of the following:
// `{ triggerActionType: 'present' }`
//    - Trigger if the field contains a non-whitespace value
// `{ triggerActionType: 'empty' }`
//    - Trigger if the field *does not* contain a non-whitespace value
// `{ triggerActionType: 'value', value: 'some value' }`
//    - Trigger if the field contains exactly 'some value' (case-insensitive match)


var getIsTriggerActive = function getIsTriggerActive(rule, doc) {
  if (!rule) return;
  var triggerFieldId = rule.triggerFieldId,
      _rule$triggerAction = rule.triggerAction,
      triggerAction = _rule$triggerAction === void 0 ? {} : _rule$triggerAction; // Get trigger type & expected value (if there is one).

  var triggerActionType = triggerAction.triggerActionType,
      expectedValue = triggerAction.value; // Get entered value.

  var fields = doc.fields;
  var triggerField = fields.find(function (f) {
    return f.id === triggerFieldId;
  });
  if (!triggerField) return false;
  var enteredValue = triggerField.value;
  enteredValue = castValue(enteredValue, triggerField);
  expectedValue = castValue(expectedValue, triggerField);

  switch (triggerActionType) {
    case 'present':
      return (0, _isFilledIn.default)(enteredValue);

    case 'empty':
      return !(0, _isFilledIn.default)(enteredValue);

    case 'value':
      return enteredValue.toLowerCase() === expectedValue.toLowerCase();

    case 'gt_value':
      return !isNaN(enteredValue) && enteredValue > expectedValue;

    case 'lt_value':
      var realEnteredValue = triggerField.value;
      return !!realEnteredValue && !isNaN(enteredValue) && enteredValue < expectedValue;

    default:
      throw new Error('Unknown trigger action type.');
  }
}; // Applies the given trigger rule to the given field.
// If the trigger condition for this rule is true, apply the rule behaviors
// against the field, otherwise if the field belongs to the trigger rule that
// has been interacted with by the user and the trigger condition is false, apply
// its default settings. If the field does not belong to the trigger rule, display
// a blank value until the user interacts with the trigger rule.


var applyTriggerRule = function applyTriggerRule(rule, field, doc, changedFieldId) {
  var triggerFieldId = rule.triggerFieldId,
      fieldGroups = rule.fieldGroups;

  var _ref2 = fieldGroups || [],
      _ref3 = _slicedToArray(_ref2, 1),
      _ref3$ = _ref3[0];

  _ref3$ = _ref3$ === void 0 ? {} : _ref3$;
  var _ref3$$fieldIds = _ref3$.fieldIds,
      fieldIds = _ref3$$fieldIds === void 0 ? [] : _ref3$$fieldIds;
  var isTriggerActive = getIsTriggerActive(rule, doc);
  var isFirstRender = !changedFieldId;
  var isUserUpdate = changedFieldId && changedFieldId === triggerFieldId;
  var isFieldUpdatedByUser = changedFieldId && changedFieldId === field.id;
  var triggerSourceValue = getTriggerSourceValue(rule, doc);
  var defaultValue = field.defaultValue,
      id = field.id,
      fieldValue = field.value;
  var value = '';

  if (isTriggerActive) {
    return applyTriggerBehaviors(rule, field, isFirstRender, isUserUpdate);
  } else if ((isUserUpdate || isFirstRender && !!triggerSourceValue) && fieldIds.includes(id)) {
    // User has updated the trigger rule source, but
    // the trigger is not active OR the document rendered
    // with a "negative" trigger rule value,
    // so we display the default value
    value = defaultValue;
  } else if (isFieldUpdatedByUser) {
    // User has updated a field, but has not updated the trigger
    // so we retain the user input
    value = fieldValue;
  } else {
    if (changedFieldId) {
      // Retain the field value when the user
      // is interacting with the document
      value = fieldValue;
    }
  }

  return _objectSpread(_objectSpread({}, field), {}, {
    value: value || ''
  });
}; // ******************** GROUP RULES ********************
// Find the first rule which contains the given rule, i.e. given rule is in the
// parent rule's conditionalRuleIds array.


var findParentRule = function findParentRule(rule, doc) {
  var ruleId = rule.id;
  var _doc$rules = doc.rules,
      rules = _doc$rules === void 0 ? [] : _doc$rules;
  return rules.find(function (_ref4) {
    var _ref4$conditionalRule = _ref4.conditionalRuleIds,
        conditionalRuleIds = _ref4$conditionalRule === void 0 ? [] : _ref4$conditionalRule;
    return conditionalRuleIds.includes(ruleId);
  });
}; // Given a group rule and one of the group's fields, is the given field required
// or disabled by the given rule?


var isGroupFieldRequired = function isGroupFieldRequired(rule, field, doc) {
  // If this rule has a parent rule whose trigger condition is false, this group
  // is disabled.
  var parentRule = findParentRule(rule, doc);
  if (parentRule && !getIsTriggerActive(parentRule, doc)) return false;
  var value = field.value,
      fieldId = field.id,
      defaultValue = field.defaultValue; // If this field has a value, all the fields in this group are required.

  if (value && value !== defaultValue) return true; // Find field group

  var fieldGroups = rule.fieldGroups;
  var thisFieldGroup = fieldGroups.find(function (_ref5) {
    var fieldIds = _ref5.fieldIds;
    return fieldIds.includes(fieldId);
  }); // If other fieldGroups in this rule are in progress, all the fields in this
  // group are disabled.

  var fields = doc.fields;
  var otherFieldGroupsAreInProgress = fieldGroups.filter(function (_ref6) {
    var id = _ref6.id;
    return id !== thisFieldGroup.id;
  }).some(function (_ref7) {
    var _ref7$fieldIds = _ref7.fieldIds,
        fieldIds = _ref7$fieldIds === void 0 ? [] : _ref7$fieldIds;
    return fieldIds.some(function (fId) {
      var _ref8 = fields.find(function (_ref9) {
        var id = _ref9.id;
        return id === fId;
      }) || {},
          fieldValue = _ref8.value,
          fieldDefaultValue = _ref8.defaultValue;

      return fieldValue && fieldValue !== fieldDefaultValue;
    });
  });
  if (otherFieldGroupsAreInProgress) return false; // Otherwise this group is required.

  return true;
}; // Get trigger rule's trigger source (field) value


var getTriggerSourceValue = function getTriggerSourceValue(triggerRule, doc) {
  if (!triggerRule) return null;
  var _doc$fields = doc.fields,
      fields = _doc$fields === void 0 ? [] : _doc$fields;
  var triggerFieldId = triggerRule.triggerFieldId;
  var triggerField = fields.find(function (_ref10) {
    var id = _ref10.id;
    return triggerFieldId === id;
  }) || {};
  return triggerField.value;
}; // Return the field value based on the group rule and any parent trigger rules'
// active/inactive state


var getGroupRuleFieldValue = function getGroupRuleFieldValue(rule, field, doc, changedFieldId) {
  var _field$value = field.value,
      fieldValue = _field$value === void 0 ? '' : _field$value,
      _field$defaultValue = field.defaultValue,
      defaultValue = _field$defaultValue === void 0 ? '' : _field$defaultValue;
  var parentRule = findParentRule(rule, doc);
  var parentRuleSourceValue = getTriggerSourceValue(parentRule, doc);
  var isParentRuleUpdated = (parentRule || {}).triggerFieldId === changedFieldId;
  var isRequired = isGroupFieldRequired(rule, field, doc);
  var isTriggerActive = getIsTriggerActive(parentRule, doc);
  var isFieldBeingUpdated = field.id === changedFieldId;
  var fieldBelongsToRule = ruleContainsField(rule, changedFieldId);
  var isDisabled = !isRequired;
  var isFirstRender = !changedFieldId;
  var isCurrentlyDefaultValue = fieldValue != null && fieldValue === defaultValue;
  var isRuleReset = !isDisabled && fieldValue === defaultValue; // The group rule has a parent trigger that has been
  // "negatively" triggered and it is the initial doc render

  var renderedWithFalsyTrigger = !isTriggerActive && isFirstRender && !!parentRuleSourceValue;
  if (isDisabled && (isParentRuleUpdated || renderedWithFalsyTrigger || fieldBelongsToRule)) return defaultValue || '';
  if (parentRule && isTriggerActive && !isDisabled && !isFieldBeingUpdated && isCurrentlyDefaultValue || isRuleReset) return '';
  return fieldValue || '';
}; // Applies the given group rule to the given field.
// If any field in a field group is filled, all fields in that group become
// required, whilst all fields in any other field groups in the same rule become
// disabled and are cleared.


var applyGroupRule = function applyGroupRule(rule, field, doc, changedFieldId) {
  var isRequired = isGroupFieldRequired(rule, field, doc);
  var value = getGroupRuleFieldValue(rule, field, doc, changedFieldId);
  var isDisabled = !isRequired;
  return _objectSpread(_objectSpread({}, field), {}, {
    // If field is in a read-only field group, set its value to default value.
    value: value,
    _derived: _objectSpread(_objectSpread({}, field._derived), {}, {
      isDisabled: isDisabled,
      isRequired: isRequired,
      // If field is in a read-only field group, show its tooltip.
      readOnlyTooltip: isDisabled ? rule.disabledFieldGroupTooltip : ''
    })
  });
}; // Returns true if field is part of the rule and false otherwise


var ruleContainsField = function ruleContainsField(rule, fieldId) {
  var _rule$fieldGroups = rule.fieldGroups,
      fieldGroups = _rule$fieldGroups === void 0 ? [] : _rule$fieldGroups;
  return fieldGroups.some(function (_ref11) {
    var _ref11$fieldIds = _ref11.fieldIds,
        fieldIds = _ref11$fieldIds === void 0 ? [] : _ref11$fieldIds;
    return fieldIds.includes(fieldId);
  });
}; // ******************** COMMON ********************
// Find the first rule applicable to the given field, i.e. given field is in one
// of the rule's field groups.


var findRuleContainingField = function findRuleContainingField(field, doc) {
  var fieldId = field.id;
  var _doc$rules2 = doc.rules,
      rules = _doc$rules2 === void 0 ? [] : _doc$rules2;
  return rules.filter(function (_ref12) {
    var ruleType = _ref12.ruleType;
    return ruleType !== 'badge' && ruleType !== 'email';
  }).find(function (_ref13) {
    var fieldGroups = _ref13.fieldGroups;
    return fieldGroups && fieldGroups.some(function (_ref14) {
      var fieldIds = _ref14.fieldIds;
      return fieldIds.includes(fieldId);
    });
  });
}; // Updates the `isReadyOnly`, `isRequired` & `readOnlyTooltip` attributes of the
// field's `_derived` object accprdomg to whatever rules are applicable.


var applyRules = function applyRules(field, doc, changedFieldId) {
  var rule = findRuleContainingField(field, doc);
  if (!rule) return field;
  var ruleType = rule.ruleType;
  return ruleType === 'trigger' ? applyTriggerRule(rule, field, doc, changedFieldId) : applyGroupRule(rule, field, doc, changedFieldId);
};

var _default = applyRules;
exports.default = _default;